import React from 'react';
import { EnrollmentSteps } from 'src/payments/constants';
import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';

import { useTrackEnrollmentStepViewed } from 'src/payments/hooks/use-dutchie-pay-analytics/use-track-enrollment-step-viewed';
import { ResetPasswordForm } from './reset-password-form';
import { useResetPassword } from './use-password-reset';

export function ResetPasswordFormWrapper(): JSX.Element {
  const { resetPassword } = useResetPassword();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const handleBackClick = (): void => DutchiePayEnrollment.setCurrentStep(EnrollmentSteps.passwordForm);

  const resetPasswordFormRef = useTrackEnrollmentStepViewed({ step: EnrollmentSteps.forgotPasswordForm });

  return (
    <div ref={resetPasswordFormRef}>
      <ResetPasswordForm onSubmit={resetPassword} onBackClick={handleBackClick} />
    </div>
  );
}
